// extracted by mini-css-extract-plugin
export default {"requests":"SupportRequests_requests__t63mT","origin":"SupportRequests_origin__pgdFG","badge":"SupportRequests_badge__IJOM5","muted":"SupportRequests_muted__H+5bW"};